import { render, staticRenderFns } from "./TokenImage.vue?vue&type=template&id=c6bfcaec"
import script from "./TokenImage.vue?vue&type=script&lang=js"
export * from "./TokenImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports